import React from "react";
import { useForm } from "react-hook-form";
import { Button, Icon, VStack } from "@chakra-ui/react";
import { MdPlayCircleFilled } from "react-icons/md";

import { login } from "api/webservice/auth";
import { saveToken } from "utils/auth";
import { useUser } from "context/user";
import { Form, Input } from "components";
import { useToast } from "hooks";
import { useHistory } from "react-router-dom";

type FormData = {
  username: string;
  password: string;
};

interface Props {
  toPath: string;
}

export const LoginForm: React.FC<Props> = ({ toPath }: Props) => {
  const { setUser } = useUser()!;
  const { handleSubmit, errors, register, formState } = useForm<FormData>();
  const toast = useToast();
  const history = useHistory();

  const validateUsername = (value: string) => {
    if (!value) {
      return "Username is required";
    } else return true;
  };

  const validatePassword = (value: string) => {
    if (!value) {
      return "Password is required";
    } else return true;
  };

  const submitForm = async ({
    username,
    password
  }: FormData): Promise<any | null> => {
    const regex = new RegExp("([!#-'*+/-9=?A-Z^-~-]+(\.[!#-'*+/-9=?A-Z^-~-]+)*|\"\(\[\]!#-[^-~ \t]|(\\[\t -~]))+\")@([!#-'*+/-9=?A-Z^-~-]+(\.[!#-'*+/-9=?A-Z^-~-]+)*|\[[\t -Z^-~]*])");
    //console.log("email entered:", regex.test(username));
    if (regex.test(username)) {
      toast({
        title: "Problem logging in",
        description: "Please log in with your username, not email.",
        status: "error"
      });
      console.log("User entered their email");
      return;
    }
    await login(username, password)
      .then(response => {
        const token = response?.token ?? null;
        const profile = response?.profile ?? null;
        if (!profile || !token) {
          toast({
            title: "Problem logging in",
            description: "Please refresh the page and try again.",
            status: "error"
          });
          return;
        }
        if (profile.privs < 1) {
          toast({
            title: "Problem logging in",
            description: "You do not have the correct role.",
            status: "warning"
          });
          return;
        }
        saveToken(token);
        setUser(profile);
        history.push(toPath);
      })
      .catch(err => {
        toast({
          title: "Problem logging in",
          description: err.response.data.response,
          status: "error"
        });
      });
  };

  return (
    <Form onSubmit={handleSubmit(submitForm)}>
      <VStack spacing={6}>
        <Input
          name="username"
          label="Username"
          hideLabel
          register={register({ validate: validateUsername })}
          placeholder="Username"
          inputIcon="user"
          errorMessage={errors.username?.message}
        />

        <Input
          name="password"
          label="Password"
          hideLabel
          placeholder="Password"
          type="password"
          inputIcon="password"
          register={register({ validate: validatePassword })}
          errorMessage={errors.password?.message}
        />

        <Button
          mt={8}
          disabled={formState.isSubmitting}
          rightIcon={
            <Icon as={MdPlayCircleFilled} w={6} h={6} color="blue.500" />
          }
          fontWeight="600"
          type="submit"
        >
          Sign In
        </Button>
      </VStack>
    </Form>
  );
};
